module.exports = __webpack_public_path__ + "img/plan-architect.77f0f97b.jpg";